import{useEffect as i}from"react";import r from"./is-running-on-client";const o=r?window:null,u=(e,t,n=o)=>{i(()=>{if(e&&n)return n.addEventListener(e,t),()=>{n.removeEventListener(e,t)}},[e,t,n])};var f=u;export{f as default};
//# sourceMappingURL=use-event.js.map
